const apiBase = 'https://api.meguru-travel.com/v1/'
export const fetchData = (api, body={}) => {
    return new Promise((resolve, reject) => {
        fetch(`${apiBase}${api}`, body).then(res => res.json()).then(res => {
            if(res.code === '0') {
                resolve(res.data)
            } else {
                reject(res);
            }
        }).catch(() => {
            reject('');
        })
    });
};